import React from "react";

export function LinkedInColorIcon() {
  return <i className="fa-brands fa-linkedin"></i>;
}
